<template>
  <div class="paymentList">
    <div id="recharge">
      <div class="recharge-container">

        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for="" class="weui-label">缴费类型</label>
          </div>
          <div class="weui-cell__bd icon-select" id="">
            <el-select v-model="value" class="weui-select icon-select" clearable placeholder="请选择缴费类型"
              @change="onSelect">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="weui-cell weui-cell_select weui-line weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for="" class="weui-label">缴费单位</label>
          </div>
          <div class="weui-cell__bd icon-select weui-line" id="">
            <el-select v-model="value2" class="weui-select icon-select" clearable placeholder="请选择缴费单位"
              @change="onSelect2" no-data-text="请先选择缴费单位" popper-class="select-down" :popper-append-to-body="false">
              <el-option v-for="item in options2" :key="item.fid" :label="item.name" :value="item.fid"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </div>
        </div>

        <div v-if="type_ac" class="weui-cell weui-line">
          <div class="weui-cell__hd ">
            <label class="weui-label">{{Account}}</label>
          </div>
          <div class="weui-cell__bd ">
            <el-input type="number" :placeholder="plac_account" v-model="input_ac" clearable>
            </el-input>
            <i class="weui-icon weui-icon-info-circle"></i>
          </div>
        </div>

        <div v-if="type_ac && idPlactype" class="weui-cell weui-line">
          <div class="weui-cell__hd ">
            <label class="weui-label">{{Identifier}}</label>
          </div>
          <div class="weui-cell__bd ">
            <el-input :placeholder="plac_id" v-model="input_id" clearable>
            </el-input>
            <i class="weui-icon weui-icon-info-circle"></i>
          </div>
        </div>

        <div v-if='power' class="weui-cell weui-line">
          <div class="weui-cell__hd ">
            <label class="weui-label">识别码B</label>
          </div>
          <div class="weui-cell__bd ">
            <el-input placeholder="6位识别编码" v-model="input_b" clearable>
            </el-input>
            <i class="weui-icon weui-icon-info-circle"></i>
          </div>
        </div>

        <div v-if='power' class="weui-cell weui-line">
          <div class="weui-cell__hd ">
            <label class="weui-label">识别码T</label>
          </div>
          <div class="weui-cell__bd ">
            <el-input placeholder="6位识别编码" v-model="input_t" clearable>
            </el-input>
            <i class="weui-icon weui-icon-info-circle"></i>
          </div>
        </div>

        <div v-if='power' class="weui-cell weui-line">
          <div class="weui-cell__hd ">
            <label class="weui-label">识别码C</label>
          </div>
          <div class="weui-cell__bd ">
            <el-input placeholder="6位识别编码" v-model="input_c" clearable>
            </el-input>
            <i class="weui-icon weui-icon-info-circle"></i>
          </div>
        </div>

        <div id="text">
        </div>

        <!-- pay  -->
        <div class="weui-cell weui-line">
          <div class="weui-cell__hd ">
            <label class="weui-label">缴费金额</label>
          </div>
          <div class="weui-cell__bd ">
            <el-input type="number" placeholder="请输入缴费金额" v-model="input_money" @input="specifiName($event)" clearable>
            </el-input>
            <i class="weui-icon weui-icon-info-circle"></i>
          </div>
        </div>

        <div class="weui-cell weui-line">
          <div class="weui-cell__hd ">
            <label class="weui-label">手&ensp;续&ensp;费</label>
          </div>
          <div class="weui-cell__bd application-flex" style="color: #d55b5b">
            &#8369;<span class='signal' style="color: #d55b5b">{{service_charge}}</span>
            <i class="weui-icon weui-icon-info-circle"></i>
          </div>
        </div>
      </div>

    </div>

    <div class="btnArea mar-15">
      <router-link to="/lifehistory" class="btn-half mar-r15">
        <el-button class="historycard " type="success">历史订单</el-button>
      </router-link>
      <el-button type='primary' @click="order" v-loading.fullscreen.lock="fullscreenLoading" class="btn-half">
        确认支付</el-button>
    </div>

    <el-dialog title="请使用扫码支付" :visible.sync="centerDialogVisible" width="300px" center>
      <div>
        <vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff" :dotScale="1"
          :logoSrc="downloadData.icon" :logoScale="0.2" :size="200"></vue-qr>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
  import vueQr from 'vue-qr'
  import config from '@/config';

  const delay = (function() {
    let timer = 0
    return function(callback, ms) {
      clearTimeout(timer)
      timer = setInterval(callback, ms)
    }
  })()
  export default {
    name: "paymentlist",
    components: {
      vueQr
    },
    data() {
      return {
        centerDialogVisible: false,
        downloadData: {
          url: '', //需要转化成二维码的网址
        },
        idPlactype: true,
        options: [{
            value: 'water',
            label: '水费'
          }, {
            value: 'electric',
            label: '电费'
          }, {
            value: 'net',
            label: '网费',

          },
        ],
        options2: null,
        value: '',
        value2: '',
        input: "",
        input_money: '',
        Account: "Account",
        Identifier: "Identifier",
        input_id: '',
        input_ac: '',
        input_b: "",
        input_c: "",
        input_t: "",
        service_charge: 50,
        act: "false",
        power: false,
        company: {},
        type_ac: false,
        plac_id: "123",
        plac_account: '321',
        database: null,
        fullscreenLoading: false
      }
    },
    mounted() {
      this.$api
        .request('System/lifeLists', {})
        .then(({ data }) => {
          this.database = data;
        })
        .catch(error => {
          this.$message({
            message: error+"获取生活缴费信息失败！",
            type: "warning"
          })
        });
    },

    methods: {
      specifiName(e) {
        if (e > 3000) {
          this.service_charge = Math.floor(e * 2 * 0.01);
        } else {
          this.service_charge = 50;
        }
      },
      order() {
        // 判断是否填写相对于数据
        this.centerDialogVisible = false;

        if (!this.value) {
          this.$message({
            message: "请输入缴费单位",
            type: "warning"
          })
          return false;
        }

        if (!this.value2) {
          this.$message({
            message: "请输入缴费单位",
            type: "warning"
          })
          return false;
        }

        if (!this.input_ac || (!this.input_id && this.idPlactype)) {
          this.$message({
            message: "请填写正确的账单信息",
            type: "warning"
          })
          return false;
        }

        if (!this.input_money) {
          this.$message({
            message: "请填写缴费金额",
            type: "warning"
          })
          return false;
        }

        let params = {};
        if (this.idPlactype) {
          params = {
            [this.Account]: this.input_ac,
            [this.Identifier]: this.input_id
          };
        } else {
          params = {
            [this.Account]: this.input_ac
          };
        }

        var paramsdata = {
          params: JSON.stringify(params),
          price: this.input_money,
          itemid: this.value2,
          service_price: this.service_charge,
          client: this.$client
        }

        if(this.$client == 'magapp') {
            paramsdata.payment = "magapay";
        }

        this.$api.request('Order/lifeCreate', paramsdata)
        .then(({ data }) => {
          switch(this.$client) {
            case 'h5':
              this.centerDialogVisible = true;
              this.downloadData.url = data.data.content;
              delay(() => {
                this.checkorder(data.data.outTradeNo)
              }, 3000)
              break;
            case 'wxh5':
              let params = JSON.parse(data.data.content);
              this.wxpay(params);
              break;
            case 'magapp':
              this.magpay(data);
              break;
            default:
              this.$message({
                message: "暂不支持的客户端！",
                type: "warning"
              })
              break;
          }
        })
        .catch(error => {
          this.$message({
            message: error,
            type: "warning"
          })
        });

      },
      magpay(params) {
        let config = {
          money: params.pay_amount,
          title: params.description,
          des: params.description,
          payWay: {
            // wallet: 1,
            weixin: 1,
            alipay: 1,
          },
          orderNum: params.oid,
          unionOrderNum: params.order_sn,
          type: params.description
        };
        mag.pay(config, () => {
          setTimeout(() => {
            this.$message({
              message: "支付成功",
              type: "warning"
            })
          }, 50);
        }, () => {
          this.$message({
            message: "支付失败",
            type: "warning"
          })
        });
      },
      wxpay(params) {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': params.appId,
            'timeStamp': params.timeStamp,
            'nonceStr': params.nonceStr,
            'package': params.package,
            'signType': params.signType,
            'paySign': params.sign
          },
          (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
              this.$router.go(0);
            }
        });
      },
      checkorder(sn) {
        this.$api
          .request('Order/check', {sn})
          .then(({ data }) => {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
          })
          .catch(error => {
            console.log(error)
          });
      },
      // 在1类型选中之后，2类型需要清空
      onSelect: function(value) {
        if (!value) {
          return false
        }

        this.value2 = "";
        this.account = false;
        this.type_ac = false;

        if (value == "water") {
          this.company = this.options2 = this.database.water;
          console.log(this.options2)
        } else if (value == "net") {
          this.company = this.options2 = this.database.net
        } else if (value == "electric") {
          this.company = this.options2 = this.database.electric
        }
        let o = this.options2; //o 是一个数组
        this.options2 = o;
      },
      onSelect2: function(value) {
        let obj = {};

        if (!this.options2 || !value) {
          return false
        }

        this.type_ac = true;

        obj = this.company.find((item) => {
          return item.fid === value
        });

        obj = JSON.parse(obj.param); //字符串转JSON
        this.plac_account = obj[0].note;
        this.Account = obj[0].paramName;

        if (obj.length > 1) {
          this.Identifier = obj[1].paramName;
          this.plac_id = obj[1].note;
          this.idPlactype = true;
        } else {
          this.idPlactype = false;
        }
      },
    }

  }
</script>
<style scoped>
  .weui-cell.weui-line:before {
    content: " ";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 1px;
    border-top: 1px solid #e5e5e5;
    color: #e5e5e5;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
    left: 15px;
    z-index: 2;

  }

  input {

    width: 100%;
  }

  .weui-cell__bd input.el-input__inne {
    border: none !important;
  }

  .el-select .el-input__inner {
    border: none !important;
  }




  #recharge {
    margin: 10px;
    font-size: 14px;
  }

  #recharge .recharge-container {
    background-color: #FFF;
    border-radius: 15px;
  }

  .weui-cell {
    padding-left: .5rem;
    padding-right: .5rem;

    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    font-weight: 700;
    font-size: 1em;
    line-height: 3rem;
    height: 3rem;
    position: relative;
  }

  .weui-cell__hd {
    width: 40%;
  }

  .weui-cell__bd {
    width: 60%;
  }

  .weui-cell_select .weui-select {}

  .el-select.weui-select.icon-select {
    width: 100%;
  }

  .weui-cell__bd.application-flex {
    text-align: left;
    box-sizing: border-box;
    padding-left: 15px;

  }

  .select-down {
    background-color: #e43;

  }

  .select-down .el-select-dropdown__item {

    padding: 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;


  }

  .btn-half {
    width: calc((100% - 15px)/2);
  }

  .well-line:before {
    content: " ";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 1px;
    border-top: 1px solid #e5e5e5;
    color: #e5e5e5;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
    left: 15px;
    z-index: 2;
  }

  .btnArea {
    box-sizing: box-sizing;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .mar-15 {
    margin-top: 20px;
    margin-left: 15px;
    margin-right: 15px;
  }

  .mar-r15 {
    margin-right: 15px;
  }

  .historycard {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/paymentlist.vue